<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid p-3">
    <div class="row mt-0">
      <div class="col-sm-12 custom-form-main-label" v-if="slotResourceId == 0">
        {{$t('add_slot')}}
      </div>
    </div>
    <div class="row mt-0" v-if="slotResourceId != 0">
      <div class="col-sm-12 custom-form-main-label">
        {{$t('manage_slot')}}
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <form id="createResourceSlotForm" name="createResourceSlotForm" class="login-formx form-validate" action="index.html" onsubmit="return false">
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('resource')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <select required class="form-control" v-bind:id="'select_assigned_resource_' +  getId()">
                <option value="" style="">{{ $store.translate('select_resource')}}</option>
                <option v-for="type in resourceTypes" v-bind:value="type.Id">
                  {{ type.Name }}
                </option>
              </select>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-6 pl-0 custom-form-label">
              {{$t('schedule_startday')}}
            </div>
            <div class="col-6 pr-0 custom-form-label">
              <span class="">
                {{$t('time')}}
              </span>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-6 pl-0 custom-form-label">
              <input type="text" v-bind:id="'txt_startdate_' +  getId()" class="form-control schedulerstartdate" style="display:inline;" />
            </div>
            <div class="col-6 pr-0 custom-form-label">
              <input type="text" v-bind:id="'txt_time_' +  getId()" class="form-control" style="display:inline;" v-model="starttime" placeholder="HH:mm" />
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-6 pl-0 custom-form-label">
              {{$t('schedule_endday')}}
            </div>
            <div class="col-6 pr-0 custom-form-label">
              <span>
                {{$t('time')}}
              </span>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-6 pl-0 custom-form-label">
              <input type="text" v-bind:id="'txt_enddate_' +  getId()" class="form-control schedulerstartdate" style="display:inline;" />
            </div>
            <div class="col-6 pr-0 custom-form-label">
              <input type="text" v-bind:id="'txt_endtime_' +  getId()" class="form-control" style="display:inline;" v-model="endtime" placeholder="HH:mm" />
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-6 px-0">
              <div class="col">
                <input-checkbox v-bind:checked="weekDayExist('Monday')" @input="setOverride" value="Monday" id="schedule_mon" name="weekday" v-bind:text="$t('monday')" class="mt-1"></input-checkbox>
              </div>
              <div class="col">
                <input-checkbox v-bind:checked="weekDayExist('Wednesday')" @input="setOverride" value="Wednesday" id="schedule_wed" name="weekday" v-bind:text="$t('wednesday')" class="mt-1"></input-checkbox>
              </div>
              <div class="col">
                <input-checkbox v-bind:checked="weekDayExist('Friday')" @input="setOverride" value="Friday" id="schedule_fri" name="weekday" v-bind:text="$t('friday')" class="mt-1"></input-checkbox>
              </div>
              <div class="col">
                <input-checkbox v-bind:checked="weekDayExist('Sunday')" @input="setOverride" value="Sunday" id="schedule_sun" name="weekday" v-bind:text="$t('sunday')" class="mt-1"></input-checkbox>
              </div>
            </div>
            <div class="col-6 px-0">
              <div class="col">
                <input-checkbox v-bind:checked="weekDayExist('Tuesday')" @input="setOverride" value="Tuesday" id="schedule_tue" name="weekday" v-bind:text="$t('tuesday')" class="mt-1"></input-checkbox>
              </div>
              <div class="col">
                <input-checkbox v-bind:checked="weekDayExist('Thursday')" @input="setOverride" value="Thursday" id="schedule_thur" name="weekday" v-bind:text="$t('thursday')" class="mt-1"></input-checkbox>
              </div>
              <div class="col">
                <input-checkbox v-bind:checked="weekDayExist('Saturday')" @input="setOverride" value="Saturday" id="schedule_sat" name="weekday" v-bind:text="$t('saturday')" class="mt-1"></input-checkbox>
              </div>

            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('capacity')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input v-model="capacity" type="number" id="txtcapacity" v-bind:placeholder="$t('capacity')" maxlength="200" name="capacity" class="form-control" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-12 custom-form-label">
              {{$t('slot_length_in_minutes)')}}
            </div>
          </div>
          <div class="form-group row mt-1">
            <div class="col-lg-12">
              <input v-model="slotlength" type="number" id="txtslotlength" v-bind:placeholder="$t('slot_length_in_minutes')" maxlength="200" name="slotlength" class="form-control" />
            </div>
          </div>
          <div class="form-group row mt-3">
            <div class="col-lg-12">
              <button @click="createResource" type="submit" class="btn skin primary-button pull-right"><i class="icon-cog5 mr-2"></i> {{$t('save')}}</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  let message = "";
  var resourceTypes = [];
  export default {
    name: "add-slot",
    components: {

    },
    props: {
      slotResourceId: {
        type: Number,
        default: 0
      },
    },
    data() {
      return {
        resourceTypes: [],
        message: "",
        resourcename: "",
        starttime: "",
        endtime: "",
        capacity: 0,
        weekdays: "",
        slotlength: 0,
      };
    },
    methods: {
      setOverride(val, value) {
        if (this.weekdays === null) {
          this.weekdays = '';
        }
        if (val) {
          this.weekdays = this.weekdays.concat(value + ',');
        } else {
          this.weekdays = this.weekdays.replace(value, '');
        }

      },
      weekDayExist(weekday) {
        if (this.weekdays !== '' && this.weekdays !== undefined && this.weekdays !== null) {
          return this.weekdays.includes(weekday);
        }
        return false;
      },
      getId() {
        return this._uid;
      },
      async getBookingResources() {
        try {
          var url = "/api/Bookings/v1/Resources?";
          this.$http.get(url).then(async response => {
            this.resourceTypes = response.data;
            $('#select_assigned_resource_' + this.getId()).select2();
          });
        }
        catch (err) {
          alert('some error:' + err)
        }
      },
      clearFields() {
        this.starttime = '';
        this.endtime = '';
        this.capacity = 0;
        this.slotlength = 0;
        this.weekdays = '';
        this.resourcename = '';
        $("#select_assigned_resource_" + this.getId()).val('');
        $("#select_assigned_resource_" + this.getId()).trigger('change');
      },
      async createResource() {
        if (!$('#createResourceSlotForm').valid())
          return false;
        var sDate = $("#txt_startdate_" + this.getId()).val();
        var edate = $("#txt_enddate_" + this.getId()).val();
        if (sDate !== '') {
          sDate = convertNormalDate(sDate);
        }
        if (edate !== '') {
          edate = convertNormalDate(edate);
        }
        var request = {
          id: this.slotResourceId,
          resourceId: $('#select_assigned_resource_' + this.getId()).val(),
          startDate: sDate,
          weekdays: this.weekdays,
          startTime: this.starttime,
          endtime: this.endtime,
          endDate: edate,
          capacity: this.capacity,
          slotlength: this.slotlength,
        };

        try {
          var response = await this.$http.post(
            '/api/Bookings/v1/Slots',
            request
          ).then(async response => {
            this.clearFields();
            vm.$root.$emit('refreshview');
          });

        } catch (err) {
          alert(err);
        }
      },
      async getBookingResource(slotResourceId) {
        try {
          this.$http.get(`/api/Bookings/v1/Slots/${slotResourceId}`).then(async response => {
            var resource = response.data;
            this.capacity = resource.Capacity;            
            this.slotlength = resource.SlotLength;
            this.weekdays = resource.Days;
            if (resource.StartDate !== '') {
              resource.StartDate = convertShortDateToLocal(resource.StartDate);
            }
            if (resource.EndDate !== '') {
              resource.EndDate = convertShortDateToLocal(resource.EndDate);
            }
            $("#txt_startdate_" + this.getId()).val(resource.StartDate);
            $("#txt_enddate_" + this.getId()).val(resource.EndDate);
            this.starttime = resource.StartTime;
            this.endtime = resource.EndTime;


            if (resource.ResourceId !== '' && resource.ResourceId !== null) {
              $("#select_assigned_resource_" + this.getId()).val(resource.ResourceId);
              $("#select_assigned_resource_" + this.getId()).trigger('change');
            } else {
              $("#select_assigned_resource_" + this.getId()).val('');
              $("#select_assigned_resource_" + this.getId()).trigger('change');
            }
          });
        } catch (err) {
          alert('some error:' + err)
        }
      }
    },
    watch: {
      slotResourceId: function (newVal, oldVal) {
        if (newVal > 0) {
          this.getBookingResource(newVal);
        } else {
          this.resourcename = '';
          this.description = '';
        }
      }
    },
    mounted() {
      _componentValidation('#createResourceSlotForm');
      if (this.slotResourceId > 0) {
        this.getBookingResource(this.slotResourceId);
      }
      //this.getBookingResources();
      $('.schedulerstartdate').daterangepicker(settings);

      $('.schedulerstartdate').on('apply.daterangepicker', function (ev, picker) {
        var tmp = thisContext.$store.getMomentLocale(picker.startDate);
        $(this).val(tmp.format("L"));
      });

      $('.schedulerstartdate').val("")
    }
  };
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/booking/add-slot.vue